package fr.frux.shared.data.mapper

import fr.frux.shared.domain.model.ClusterPoint
import fr.frux.shared.domain.model.ClusterPyramid
import fr.frux.shared.domain.model.IsolatedTree
import fr.frux.shared.domain.model.SpeciesCount
import fr.frux.shared.domain.model.TreeStatus
import fr.frux.shared.dto.ClusterPointDto
import fr.frux.shared.dto.ClusterPyramidDto

fun ClusterPyramidDto.toDomain(): ClusterPyramid =
    ClusterPyramid(
        maxZoom = maxZoom,
        detailZoom = detailZoom,
        generatedAt = generatedAt,
        points = points.map { it.toDomain() },
    )

private fun ClusterPointDto.toDomain(): ClusterPoint {
    // Un arbre isolé porte une seule espèce. Sans elle, le point reste un point sans fiche.
    val speciesId = species.firstOrNull()?.id
    val isolatedId = treeId
    val tree =
        if (isolatedId != null && speciesId != null) {
            IsolatedTree(
                id = isolatedId,
                speciesId = speciesId,
                // Le serveur omet le statut inconnu.
                status = status?.toDomain() ?: TreeStatus.UNKNOWN,
                lastObservedAt = observedAt,
                needsCheck = needsCheck,
                locked = locked,
            )
        } else {
            null
        }
    return ClusterPoint(
        latitude = lat,
        longitude = lon,
        zoom = z,
        count = n,
        expansionZoom = e,
        species = species.map { SpeciesCount(speciesId = it.id, count = it.n) },
        tree = tree,
    )
}
